import React from 'react'
import PropTypes from 'prop-types'
import usePWAInstallPrompt from '../../pwa/usePWAInstallPrompt'

function PWAInstallButton({ vCard }) {
  const { canInstall, promptInstall } = usePWAInstallPrompt(vCard)
  if (!vCard || vCard.pwaEnabled !== true || !canInstall) return null
  const color = vCard.theme?.primaryColor || '#2563eb'
  return (
    <button
      onClick={promptInstall}
      className="fixed bottom-6 left-6 z-50 px-4 py-2 rounded-full shadow-lg text-white font-medium hover:scale-105 transition-transform"
      style={{ backgroundColor: color }}
      aria-label="Instalar aplicación"
    >
      Instalar App
    </button>
  )
}

PWAInstallButton.propTypes = {
  vCard: PropTypes.object.isRequired
}

export default PWAInstallButton
